import { UrlSegmentDelimiter } from '../../constants-repository/app-style.constants';

export class ShiveRoutes {
  // ////// Generic routes
  public static readonly Create = 'create';
  public static readonly Edit = 'edit';
  public static readonly Detail = 'detail';
  public static readonly Progress = 'progress';
  public static readonly Overview = 'overview';

  // ////// Shared Routes
  public static readonly Attachments = 'attachments';
  public static readonly Expenses = 'expenses';
  public static readonly BaseData = 'base-data';
  public static readonly AnyId = '*';

  // Auth
  public static readonly Auth = 'auth';
  public static readonly Login = 'login';
  public static readonly Logout = 'logout';

  // Invitation
  public static readonly Invite = 'invite';
  public static readonly Resolve = 'resolve';
  public static readonly Accept = 'accept';

  // Dashboard
  public static readonly Dashboard = 'dashboard';

  // TimeTracking
  public static readonly TimeTracking = 'time-tracking';
  public static readonly Calendar = 'calendar';
  public static readonly List = 'list';
  public static readonly CalendarView =
    ShiveRoutes.TimeTracking + UrlSegmentDelimiter + ShiveRoutes.Calendar;
  public static readonly ListView =
    ShiveRoutes.TimeTracking + UrlSegmentDelimiter + ShiveRoutes.List;

  // Projects
  public static readonly Projects = 'projects';
  public static readonly ProjectOverview =
    ShiveRoutes.Projects + UrlSegmentDelimiter + ShiveRoutes.Overview;
  public static readonly ProjectAdd =
    ShiveRoutes.Projects + UrlSegmentDelimiter + ShiveRoutes.Create;
  public static readonly ProjectProgress =
    ShiveRoutes.Projects +
    UrlSegmentDelimiter +
    ShiveRoutes.Detail +
    UrlSegmentDelimiter +
    ShiveRoutes.Progress;
  public static readonly ProjectEdit =
    ShiveRoutes.Projects +
    UrlSegmentDelimiter +
    ShiveRoutes.Detail +
    UrlSegmentDelimiter +
    ShiveRoutes.Edit;
  public static readonly ProjectExpenses =
    ShiveRoutes.Projects +
    UrlSegmentDelimiter +
    ShiveRoutes.Detail +
    UrlSegmentDelimiter +
    ShiveRoutes.Expenses;
  public static readonly ProjectAttachments =
    ShiveRoutes.Projects +
    UrlSegmentDelimiter +
    ShiveRoutes.Detail +
    UrlSegmentDelimiter +
    ShiveRoutes.Attachments;

  // Clients
  public static readonly Clients = 'clients';
  public static readonly ClientList =
    ShiveRoutes.Clients + UrlSegmentDelimiter + ShiveRoutes.Overview;
  public static readonly ClientAdd = ShiveRoutes.Clients + UrlSegmentDelimiter + ShiveRoutes.Create;
  public static readonly ClientEdit = ShiveRoutes.Clients + UrlSegmentDelimiter + ShiveRoutes.Edit;

  // Team
  public static readonly Team = 'team';
  public static readonly Absences = 'absences';
  public static readonly Planner = 'planner';
  public static readonly VacationQuota = 'vacation-quota';
  public static readonly LeaveRequests = 'leave-requests';

  public static readonly TeamOverview =
    ShiveRoutes.Team + UrlSegmentDelimiter + ShiveRoutes.Overview;
  public static readonly TeamMemberAdd =
    ShiveRoutes.Team + UrlSegmentDelimiter + ShiveRoutes.Create;
  public static readonly TeamAbsences = `${ShiveRoutes.Team + UrlSegmentDelimiter + ShiveRoutes.Absences}`;
  public static readonly TeamAbsencePlanner = `${ShiveRoutes.Team + UrlSegmentDelimiter + ShiveRoutes.Absences + UrlSegmentDelimiter + ShiveRoutes.Planner}`;
  public static readonly TeamVacationQuota = `${ShiveRoutes.Team + UrlSegmentDelimiter + ShiveRoutes.Absences + UrlSegmentDelimiter + ShiveRoutes.VacationQuota}`;
  public static readonly TeamLeaveRequests = `${ShiveRoutes.Team + UrlSegmentDelimiter + ShiveRoutes.Absences + UrlSegmentDelimiter + ShiveRoutes.LeaveRequests}`;

  // Finances
  public static readonly Finances = 'finances';
  public static readonly Invoices = 'invoices';
  public static readonly OperatingExpenses = 'operating-expenses';

  public static readonly FinancesInvoicesOverview =
    ShiveRoutes.Finances +
    UrlSegmentDelimiter +
    ShiveRoutes.Invoices +
    UrlSegmentDelimiter +
    ShiveRoutes.Overview;
  public static readonly FinancesInvoicesAdd =
    ShiveRoutes.Finances +
    UrlSegmentDelimiter +
    ShiveRoutes.Invoices +
    UrlSegmentDelimiter +
    ShiveRoutes.Create;
  public static readonly FinancesExpenses =
    ShiveRoutes.Finances + UrlSegmentDelimiter + ShiveRoutes.OperatingExpenses;

  // User
  public static readonly User = 'user';
  public static readonly UserEdit = ShiveRoutes.User + UrlSegmentDelimiter + ShiveRoutes.Edit;
  public static readonly UserAttachments =
    ShiveRoutes.User + UrlSegmentDelimiter + ShiveRoutes.Attachments;

  // Reports
  public static readonly ReportsTimetable = 'timetable';
  public static readonly ReportsTimetableMonthly = 'monthly';
  public static readonly ReportsTimetableTimeEntries = 'entries';

  public static readonly Reports = 'reports';
  public static ReportsTimeTableAggregated =
    ShiveRoutes.Reports + UrlSegmentDelimiter + ShiveRoutes.ReportsTimetable;

  // TodoPlanner
  public static readonly TodoPlanner = 'my-todos';

  // /////// Settings
  public static readonly Settings = 'settings';

  // Time Off
  public static readonly TimeOff = 'time-off';
  public static readonly SettingsNonworkingTime =
    ShiveRoutes.Settings + UrlSegmentDelimiter + ShiveRoutes.TimeOff;

  // ////// Printing
  public static readonly Print = 'print';
  public static readonly Invoice = 'invoice';
  public static readonly PrintInvoice =
    ShiveRoutes.Print + UrlSegmentDelimiter + ShiveRoutes.Invoice;
}
